export const colors = {
    WHITE: '#ffffff',
    BLACK: '#000000',
    RED: '#fc3d40',
    GREY: '#c5cacf',
    LIGHT_GREY: '#4e5d6c',
    DARK_GREY: '#4d4d4d',
    YELLOW: '#ffc315',
    FACEBOOK_BLUE: '#4469b0',
    MAIN_BLACK: '#0e0e0e',
};

export const colorNames = {
    WHITE: 'white',
    YELLOW: 'yellow',
    FACEBOOK_BLUE: 'facebookBlue',
    MAIN_BLACK: 'mainBlack',
    GREY: 'grey',
    LIGHT_GREY: 'lightGrey',
    DARK_GREY: 'darkGrey',
};

export const gradientNames = {
    ORANGE: 'orange',
};



// WEBPACK FOOTER //
// ./src/Constants/colors.js